import React from "react";

export const Image = ({ title, largeImage, smallImage }) => {
  return (
    <div className="portfolio-item" style={{ padding: "2px" }}>
      <div className="hover-bg">
        <a href={largeImage} title={title} data-lightbox-gallery="gallery1" target="_blank" rel="noreferrer">
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img
            src={smallImage}
            alt={title}
            style={{
              width: "100%",
              height: "220px",
              objectFit: "cover",
              display: "block",
            }}
          />
        </a>
      </div>
    </div>
  );
};
